
import { useState } from 'react';
import { LocationState, Permission, STORAGE_KEYS } from './types';
import { getFromStorage } from './storage-utils';

/**
 * Hook for managing location state
 */
export const useLocationState = () => {
  // Initialize state from storage with better error handling
  const [locationState, setLocationState] = useState<LocationState>(() => {
    const savedPermission = getFromStorage<Permission>(STORAGE_KEYS.PERMISSION);
    const savedLocation = getFromStorage<any>(STORAGE_KEYS.COORDS, JSON.parse);
    const locationTimestamp = getFromStorage<number>(STORAGE_KEYS.TIMESTAMP, Number);
    
    return {
      coords: savedLocation,
      permission: savedPermission || 'prompt',
      isLoading: false,
      error: null,
      permissionTransitioning: false,
      lastUpdated: locationTimestamp,
      initialized: false // Added the missing initialized property
    };
  });

  return { locationState, setLocationState };
};

/**
 * Hook for managing prompt state
 */
export const usePromptState = () => {
  const [promptState, setPromptState] = useState(() => {
    return {
      lastPromptTime: getFromStorage<number>(STORAGE_KEYS.LAST_PROMPT, Number),
      promptCount: getFromStorage<number>(STORAGE_KEYS.PROMPT_COUNT, Number) || 0,
      interactionCount: getFromStorage<number>(STORAGE_KEYS.INTERACTIONS, Number) || 0,
      cooldownEndTime: getFromStorage<number>(STORAGE_KEYS.COOLDOWN, Number),
      hasShownPrompt: !!getFromStorage(STORAGE_KEYS.PERMISSION),
    };
  });

  return { promptState, setPromptState };
};

/**
 * Hook for managing "do not show again" preference
 */
export const useDoNotShowAgainState = () => {
  const [doNotShowAgain, setDoNotShowAgain] = useState<boolean>(
    !!getFromStorage<boolean>(STORAGE_KEYS.DO_NOT_SHOW_AGAIN)
  );

  return { doNotShowAgain, setDoNotShowAgain };
};
